export default __webpack_public_path__ + "static/media/card.d0afbbd2.png";